export default {"src":"/_next/static/media/partenaLogoBlue.dde27cb7.svg","height":82,"width":225};